export default __webpack_public_path__ + "static/media/non_auth_empty_favorites.4c36f9ca.svg";